import React from 'react'
import { Card, CardActivity } from '../../components/Card';
import Calendar from '../../components/Calendar';
import { StyledHealthCalendarContent } from './styled';
import Days from '../../components/Days';
import Divider from '../../components/Divider';
import { CardHeader } from '../../components/Card';
import { length } from 'ramda';

const Activities = ({ activities, calendar }) => {
    return (
        <Card>
            {
                activities.title &&
                <CardHeader>
                    {activities.title}
                </CardHeader>
            }
            <Calendar
                days={calendar}
                content={(renderedDays) => {
                    const filterDays = (days) => {
                        return days.filter(day => renderedDays.map(renderedDay => renderedDay.stamp).includes(day.stamp)).sort((a, b) => a.stamp - b.stamp);
                    }

                    return (
                        <StyledHealthCalendarContent>
                            {activities && activities.data.map((activity, index) => (
                                <React.Fragment key={activity.title}>
                                    <CardActivity
                                        title={activity.title}
                                        values={activity.days && <Days daysLength={length(renderedDays)} items={filterDays(activity.days)} />}
                                    />
                                    {index < activities.data.length - 1 && <Divider />}
                                </React.Fragment>
                            ))}
                        </StyledHealthCalendarContent>
                    )
                }}
            />
        </Card>
    )
}

export default Activities